<template>

  <div class="atividades-sacsolicitacoes ml-4 mr-4" >
      <b-form>          
          <b-row>
              <!-- -->
              <b-col cols="6">
                <label for="select-garagem">Garagem</label>         <!--  --- {{user.id_funcionario_erp}} -->
                <multiselect  v-model="value_garagem" required 
                  :options="garagens" 
                  :multiple="true" 
                  :close-on-select="false" 
                  :clear-on-select="false" 
                  :preserve-search="true"   placeholder="Selecione a garagem" label="garagem" track-by="garagem" name="garagem"
                  :preselect-first="true">
                  <template slot="selection" slot-scope="{ values,isOpen }"><span class="multiselect__single" v-if="values.length &amp;&amp; !isOpen">{{ values.length }} Garagem selecionada</span></template>
                </multiselect> 
              </b-col>

              <b-col>
                   <div>                            
                        <label  for="datepicker-placeholder">Data escala de serviço</label>
                        <b-form-datepicker id="datepicker-placeholder"  v-model="data_servico" placeholder="Selecione uma data" locale="pt-BR" date-format-options="DD/MM/YYYY"></b-form-datepicker>
                    </div>                     
              </b-col>

              <b-col cols="2">
                <br>                 
                <b-button variant="primary" class="mr-2 mt-2" :disabled="carregando" @click="carregando = true,loadSolturaFrota()">
                  <b-spinner v-if="carregando" small style="margin-bottom: 3px ;" > </b-spinner > Pesquisar
                </b-button>                      
              </b-col>
          </b-row>
    </b-form>

    <b-col>
      <div >                     
       
       <b-progress class="mt-3 mp-3" :max="barra_limite">
        <b-progress-bar variant="success"  :value="barra_inicial" :label="`${((barra_inicial / barra_limite) * 100).toFixed(2)} %`"></b-progress-bar>
      </b-progress>

      </div>
    </b-col>


    
    <div class="d-flex justify-content-center mb-3">
      <b-spinner v-if="atualizando" label="Loading..."></b-spinner>
    </div>    
    <!--tbl de dados -->
    <b-table id="solturafrotas"  small hover striped sticky-header="550px"  :items="solturafrotas" :fields="fields" >    
        <template slot="cell(actions)" slot-scope="data"  >
          <b-button  @click="loadCarregaFrota(data.item)"    title="Acessar Tabela"  size="sm" variant="primary" class="mr-2 mt-2" v-b-modal.modal-multi-1>                
            <i class="fa fa-exclamation-circle"></i>              
          </b-button> 
        </template>   
    </b-table>

      <!--  MODAL GRAVAÇÃO RELACAO DA FROTA INDISPONIVEL -->
      <!--  MODAL GRAVAÇÃO RELACAO DA FROTA INDISPONIVEL -->

      <div>        
    <b-modal id="modal-multi-1" cancel-title="Fechar"  @cancel="reset()"  ok-title="Gravar" @ok="postFrota(),loadSolturaFrota()"  size="lg" title="Frota - Alteração.:"   no-close-on-esc no-close-on-backdrop>
          <!-- -->
          <div>

            <b-row>
              <input  id="id-tabela_alt" type="hidden" v-model="solturafrota.id_tabela" />
              <input  id="id-carro_alt " type="hidden" v-model="carros.id_carro" />
              
              <b-col cols="3">
                <label for="input-live">Linha</label> 
                <b-form-input  id="carro" v-model="solturafrota.linha" readonly placeholder=""></b-form-input>
              </b-col>

              <b-col cols="3">
                <label for="input-live">Tabela</label>
                <b-form-input id="funcao" v-model="solturafrota.tabela" readonly placeholder=""></b-form-input>              
              </b-col>

              <b-col cols="6">
                <label for="input-live">Carro</label>
                <b-form-input id="funcao" v-model="solturafrota.carro" readonly placeholder=""></b-form-input>              
              </b-col>

            <b-col cols="12">
              

              <div>
                <label for="input-Responsabilidade" class="mt-2">Responsabilidade</label>          
                <b-form-select   id="responsabilidade"               
                  v-model="solturafrota.id_motivo"  
                  :options="responsabilidades"
                  class="mb-3"
                  text-field="motivo"                            
                >                
                </b-form-select>
              </div>
            </b-col> 


            </b-row>

            <!--teste -->

            <b-row>
              <input  id="id-sac" type="hidden" v-model="solturafrota.id_tabela" />
              
              <b-col cols="3">
                <label for="input-live">Carro</label> <!-- -- {{carros.id_carro}} -->
                <b-form-input v-model="carros.carro" @keyup.enter="loadCarros()" id="carro" placeholder="digite o novo prefixo"></b-form-input>
              </b-col>

              <b-col cols="6">
                <label for="input-live">Chassi</label>
                <b-form-input v-model="carros.chassi" id="funcao"  readonly placeholder=""></b-form-input>              
              </b-col>

              <b-col cols="3">
                <label for="input-live">Placa</label>
                <b-form-input id="funcao" v-model="carros.placa"  readonly placeholder=""></b-form-input>              
              </b-col>


            </b-row> 
          </div>          
        </b-modal>
      </div>
      <!--  MODAL GRAVAÇÃO RELACAO DA FROTA INDISPONIVEL -->

  </div>  

</template>


<script>
import { baseApiUrl, showError } from '@/global'
import { mapState } from 'vuex' 
import axios from 'axios'
import Multiselect from 'vue-multiselect'
import moment from 'moment'


export default {    
    name: 'SacSolicitacao',
    computed: mapState(['user']),    

    data: function() {        
      
        return {
            mode: 'save',
            carregando: false,
            atualizando: false,            
            garagem:{}, 
            garagens: [],   // [] lista  
            
            responsabilidade:{},
            responsabilidades:[],

            value_garagem:[],// [] lista     
            
            solturafrota:{},// [] lista   
            solturafrotas:[],// [] lista
            value_status:'',
            data_servico: '', 
            carros:[] ,
            value_carro:'',          
            
            barra_inicial: 0,         
            barra_limite: 60000,

            fields: [                
               // { key: 'id_garagem', label: 'Garagem', sortable: true },                 
                { key: 'linha', label: 'Linha', sortable: true },  
                { key: 'tabela', label: 'Tabela', sortable: true },  
                { key: 'carro', label: 'Carro', sortable: true },  
                { key: 'modalidade', label: 'Modalidade ', sortable: true },                                     
                { key: 'dh_hora_chegada', label: 'Saida Garagem', sortable: true, formatter: (value, key, solturafrotas) => {
                    return moment(solturafrotas.dh_hora_chegada).format('HH:mm').replace('Data inválida','-') ; }  },
                { key: 'atividade', label: 'Atividade', sortable: true },       
                { key: 'local_pegada', label: 'Local de pegada', sortable: true },       

                { key: 'actions', label: 'Ações' },                
            ]
        }        
    },

    components: {
        Multiselect
    },
    methods: {
      

      temporizador() {
      this.handle = setInterval(() =>{
        this.barra_inicial = this.barra_inicial + 1000
        if(this.barra_inicial >= this.barra_limite){
          this.barra_inicial = 0
          this.loadSacSolicitacoes()
        }
      },1000)
      },
      
        loadGaragens() {
          const url = `${baseApiUrl}/manutencao/rfi/garagem`
          axios.get(url).then(res => {
            this.garagens = res.data.map(garagem => {              
              return { id_garagem: garagem.id_filial, garagem: garagem.garagem }
            })
          })
        },
        
        loadResponsabilidades() {
          const url = `${baseApiUrl}/trafego/frota/responsabilidade`
          axios.post(url).then(res => {
            this.responsabilidades = res.data.map(resp => {              
              return { ... resp, value: resp.id_motivo, motivo: resp.motivo }
            })
          })
        },
        
        loadCarros() {          
          const url = `${baseApiUrl}/despachante/carro/${this.carros.carro}`
          axios.get(url).then(res => { this.carros = res.data })          
        },
        
          reset() {            
            this.carros = {}
            
        },

        loadSolturaFrota() {                        
            let corpo = {    
                "id_garagem": `${[this.value_garagem.map(a => a.id_garagem)]}`,                
                "data_servico": `${this.data_servico}`                
            };
 
            const url = `${baseApiUrl}/trafego/frota`            
            axios.post(url,corpo).then(res => {                                
                this.carregando = false;
                this.solturafrotas = res.data.map(solturafrota => {
                            return {                              
                              id_garagem: solturafrota.id_garagem, 
                              id_tabela: solturafrota.id_tabela, 
                              data_servico: solturafrota.data_servico,
                              tabela: solturafrota.tabela,
                              linha: solturafrota.linha, 
                              modalidade: solturafrota.modalidade,
                              id_carro: solturafrota.id_carro,
                              carro: solturafrota.carro,
                              atividade: solturafrota.atividade,
                              local_pegada: solturafrota.local_pegada,
                              dh_hora_chegada: solturafrota.dh_hora_chegada
                             
                            }              
                                                })
                        })            
        }, 

        loadCarregaFrota(solturafrota){
            this.solturafrota = { ...solturafrota }
        },

        postFrota() {                        
        let corpo = { 
                "descricao_resposta": `${this.solturafrota.resposta}`,
                "id_solicitacao": `${this.solturafrota.id_solicitacao}`,
                "id_status": `${this.solturafrota.id_status}`,
                "status": `${[this.statuss.filter(a => a.id_status == this.solturafrota.id_status).map(a => a.status)]}`
        };

        const url = `${baseApiUrl}/sac/solicitacoes/save`   

            axios.post(url,corpo).then(() => {
                    this.$toasted.global.defaultSuccess()
                    //this.reset() limpar os objetos valores
                })
                .catch(showError)
        },
  
    },

    mounted() {                             
        this.temporizador()                  
        this.loadGaragens()  
        this.loadResponsabilidades()                          
        this.loadSolturaFrota()
        this.loadCarregaFrota()        
    },
}

</script>
<style src="vue-multiselect/dist/vue-multiselect.min.css"></style>
<style>

#selecaostatusx{
    font-size: 0.7em;      
}

#rfilancamentos{   
    font-size: 0.9em;      
    text-align: center;    
}
</style>